import { Command, Store } from '@nextforce/api'
import { Button, ListItem, makeStyles } from '@rneui/themed'
import { font } from 'app/theme'
import { NonAvailabilityGrid } from 'non_availability/non_availability_grid'
import { StoreUserNonAvailability } from 'non_availability/queries/types'
import { Cell } from 'non_availability/types'
import { ScrollView, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { CommandButtons } from 'shared/components/command_buttons'
import { UserAvatar } from 'shared/components/user/user_avatar'
import { useUser } from 'users/queries/detail'

interface Props {
  store?: Store
  cells?: Cell[]
  nonAvailability?: StoreUserNonAvailability
  onCommandButtonPress: (
    command: Command,
    nonAvailability: StoreUserNonAvailability
  ) => Promise<void>
}

export function NonAvailabilityRequestView({
  store,
  cells,
  nonAvailability,
  onCommandButtonPress,
}: Props) {
  const styles = useStyles()
  const { data: currentUser } = useUser()
  if (!store || !nonAvailability) return

  const user = nonAvailability.user
  const isObserver = currentUser?.role === 'observer'
  const hasCommands =
    nonAvailability?.commands && nonAvailability?.commands?.length > 0

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={{ flex: 1 }}>
      <ScrollView
        contentContainerStyle={styles.container}
        scrollEnabled
        bounces
      >
        {isObserver && (
          <ListItem containerStyle={styles.user}>
            <UserAvatar user={user} size={'medium'} showAvatarIfNoPhone />
            <ListItem.Title
              style={styles.userName}
            >{`${user?.firstName} ${user?.lastName}`}</ListItem.Title>
          </ListItem>
        )}

        <NonAvailabilityGrid store={store} cells={cells} disableSelection />
        <View style={styles.footer}>
          {nonAvailability?.status !== 'PENDING' || !hasCommands ? (
            <Button
              title={nonAvailability?.status}
              titleProps={{ allowFontScaling: false }}
              disabled
              disabledStyle={styles.button}
              disabledTitleStyle={styles.title}
            />
          ) : (
            <CommandButtons
              commands={nonAvailability?.commands}
              onButtonPress={command =>
                onCommandButtonPress(command, nonAvailability)
              }
            />
          )}
        </View>
      </ScrollView>
    </SafeAreaView>
  )
}

export const BUTTON_HEIGHT = 40

const useStyles = makeStyles(theme => ({
  container: {
    flexGrow: 1,
    padding: 16,
    paddingTop: 30,
    backgroundColor: theme.colors?.white,
  },
  button: {
    height: BUTTON_HEIGHT,
    borderRadius: 15,
    backgroundColor: theme.colors.grey6,
    margin: 5,
  },
  title: {
    textAlign: 'center',
    fontSize: 17,
    fontFamily: font.bold,
    color: theme.colors?.grey2,
  },
  footer: {
    padding: 20,
  },
  user: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 0,
    marginTop: 0,
  },
  userName: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
}))
